import { Route, Routes } from "react-router-dom";

import ErrorPage from "./contents/ErrorPage";
import HomePage from "./contents/HomePage";
import PdfViewer from "./contents/PdfViewer";
import DocumentViewer from "./contents/DocumentViewer";
import Footer from "./contents/Footer";
const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/PdfViewer" element={<PdfViewer />} />
            <Route path="/DocumentViewer" element={<DocumentViewer />} />
            <Route path="/Footer" element={<Footer />} />


            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};

export default AppRoutes;
